const deferredEvents = [];
const sendEvents = () => {
    if (window.ajaxLogger) {
        deferredEvents.forEach((params) => window.ajaxLogger.logMetric(params, ['jsv']));
        deferredEvents.length = 0; // clear array items by setting its length to zero
    }
    else {
        setTimeout(sendEvents, 100);
    }
};
// Usage: JsvMetricsLogger.log("trigger", "metric", "element", {custom_param: val})
export const log = (trigger, metric, element, extraParams) => {
    const params = {
        trigger,
        metric,
        element,
        ...extraParams
    };
    deferredEvents.push(params);
    sendEvents();
};
export default { log };
